import { render } from "./GuiTariffDetailSelect.vue?vue&type=template&id=56fffd34"
import script from "./GuiTariffDetailSelect.vue?vue&type=script&lang=js"
export * from "./GuiTariffDetailSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__